import statusTypes from "./status-types";


export default statusTypes.reduce((obj, item) => {
    return {
        ...obj,
        [item.code]: item.color,
    };
});